import Alert from '@mui/material/Alert';
import { FormattedMessage } from 'react-intl';

import useProjectSurveyQuery from '../../api/hooks/queries/useProjectSurveyQuery';

export function ExternalLinkHint() {
  const { data } = useProjectSurveyQuery();

  if (data?.engine !== 'EXTERNAL') {
    return null;
  }

  return (
    <Alert severity="info">
      <FormattedMessage
        id="upload.externalLink.hint"
        defaultMessage="Soubor musí mít sloupec ExternalLink s odkazem na dotazník v každém řádku."
      />
    </Alert>
  );
}
